import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getUsers } from 'Selectors/common';

interface UserNameCellRendererProps {
    value: string;
}

const UserNameCellRenderer = (props: UserNameCellRendererProps) => {
    const { value } = props;

    const users = useAppSelector(getUsers);
    const user = users[value];

    return (
        <span>{user ? `${user.FirstName} ${user.LastName}` : '-'}</span>
    );
};

export default UserNameCellRenderer;